import DepositProtectionLabelDescription from './DepositProtectionLabelDescription';

export default DepositProtectionLabelDescription;
